import type { BillingInterval } from '../types';
import { addMonths, BILLING_INTERVAL_MONTHS } from './billingPlans';

export { addMonths, BILLING_INTERVAL_MONTHS };

export function getListingValidUntil(business: {
  listingValidUntil?: string;
  activatedAt?: string;
  billingInterval?: BillingInterval;
}): Date | null {
  if (business.listingValidUntil) {
    return new Date(business.listingValidUntil);
  }

  if (business.activatedAt) {
    const months = BILLING_INTERVAL_MONTHS[business.billingInterval ?? 'monthly'];
    return addMonths(new Date(business.activatedAt), months);
  }

  return null;
}

export function formatListingDate(date: Date): string {
  return date.toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function getBusinessCoverPhotoUrl(business: {
  photoPreviewUrls?: string[];
  importedPhotoUrls?: string[];
}): string | null {
  return business.photoPreviewUrls?.[0] ?? business.importedPhotoUrls?.[0] ?? null;
}
